import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const scriptDonwloadPlugin = createPlugin({
  id: 'script-donwload',
  routes: {
    root: rootRouteRef,
  },
});

export const ScriptDonwloadPage = scriptDonwloadPlugin.provide(
  createRoutableExtension({
    name: 'ScriptDonwloadPage',
    component: () =>
      import('./components/OptimizedScriptDownload').then(
        m => m.OptimizedScriptDownload,
      ),
    mountPoint: rootRouteRef,
  }),
);
